import React from 'react'
import './new-student-form-two.css'

import { withFormik, Form, Field, FieldArray } from 'formik'
import * as Yup from 'yup'
import MaskedInput from 'react-text-mask'
import PlacesAutocomplete from 'react-places-autocomplete'
import Axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { createStudentOnboardingCard2022FromNewStudentForm } from '../../AdminWorkflows/WorkflowModels'

const NewStudentFormTwo = ({
        values,
        errors,
        touched,
        isSubmitting,
        setSubmitting,
        handleSubmit,
        setValues,
        resetForm,
        field
    }) => {

        const [address, setAddress] = React.useState('')
        const [card, setCard] = React.useState(0)
        const [school, setSchool] = React.useState('')
        const [abbreviation, setAbbreviation] = React.useState('')
        const [website, setWebsite] = React.useState('')
        const [logoName, setLogoName] = React.useState('')
        const [email, setEmail] = React.useState('')
        const [addressState, setAddressState] = React.useState('')
        const [weGotIt, setWeGotIt] = React.useState(false)
        const [loading, setLoading] = React.useState(false)
        const [myError, setMyError] = React.useState(false)
        const [listOfInst, setListOfInst] = React.useState([])

        const phoneNumberMask = ["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
        const dateMask = [/[0-9]/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

        React.useEffect(() => {
            setTheSchool()
            Axios.get(`${baseUrl}/inst`)
            .then((res) => {
                let sortedInst = res.data.sort((a, b) => a.name.localeCompare(b.name))
                setListOfInst(sortedInst)
                //console.log(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
        },[])

        //ADD AND REMOVE EVENT LISTENER
        React.useEffect(() => {
            window.addEventListener('keydown', handleUserPressingEnter);
        
            return () => {
              window.removeEventListener('keydown', handleUserPressingEnter);
            };
        });

        const handleUserPressingEnter = (e) => {
            if(e.key === 'Enter' || e.code === 'Enter') {
                if(card === 0) {
                    if(values.primaryEmail && !errors.primaryEmail) {
                        changeTheCard(1, 0, 'right', 'url(./about-img.jpg)')
                    }
                } else if (card === 1) {
                    if(values.primaryParentName && !errors.primaryParentName && values.familyName && !errors.familyName && values.primaryCellphone && !errors.primaryCellphone && !errors.address.addressLine1 && values.address.addressLine1) {
                        changeTheCard(2, 1, 'left', 'url(./privateteacherinboulder.jpg)')
                    }
                } else if (card === 2) {
                    if(values.students[0].studentName) {
                        changeTheCard(3, 2, 'right', 'url(./privatelessonsinboulder.jpg)')
                    }
                } else if (card === 3) {
                    sendFormToDatabase()
                }
            }
        }

        const handleChange= (value, values, setValues) => {
            setAddress(value)
            let address = {
                addressLine1: value,
                addressLine2: '',
                city: '',
                state: '',
                zipcode: 0
            }
            setValues({...values, address})
        }

        const handleSelect = (value) => {
            setAddress(value)
        }

        const setTheSchool = () => {
            let url = window.location.href
            let trimmed = url.substring(8)
            let name = trimmed.split('.')[0]
            if(name === 'mountainside') {
                    setSchool('Mountainside Music Academy')
                    setAbbreviation('MMA')
                    setWebsite('https://www.mountainsidemusicacademy.com')
                    setLogoName('mmalogo.png')
                    setEmail('info@mountainsidemusicacademy.com')
                    setAddressState('CO')
            } else if (name === 'lakeside') {
                    setSchool('Lakeside Music Academy')
                    setAbbreviation('LSMA')
                    setWebsite('https://www.lakesidemusicacademy.com')
                    setLogoName("lakesidelogo.png")
                    setEmail('info@lakesidemusicacademy.com')
                    setAddressState('MN')
            } else if (name === 'treeside') {
                    setSchool('Treeside Music Academy')
                    setAbbreviation('TMA')
                    setWebsite('https://www.treesidemusicacademy.com')
                    setLogoName('treesidelogo.png')
                    setEmail('info@treesidemusicacademy.com')
                    setAddressState('MI')
            } else if (name === 'greatlakes') {
                    setSchool('Great Lakes Music Academy')
                    setAbbreviation('GLMA')
                    setWebsite('https://www.greatlakesmusicacademy.com')
                    setLogoName('greatlakeslogo.png')
                    setEmail('info@greatlakesmusicacademy.com') 
                    setAddressState('IL')
            } else if (name === 'morningside') {
                setSchool('Morningside Music Academy')
                setAbbreviation('MOR')
                setWebsite('https://www.morningsidemusicacademy.com')
                setLogoName('morningsidelogo.png')
                setEmail('info@morningsidemusicacademy.com') 
                setAddressState('OR')
            } else if (name === 'parkside') {
                setSchool('Parkside Music Academy')
                setAbbreviation('PSMA')
                setWebsite('https://www.parksidemusicacademy.com')
                setLogoName('parksidelogo.png')
                setEmail('info@parksidemusicacademy.com') 
                setAddressState('WA')
            }
            else if (name === 'denton') {
                setSchool('Denton Music Academy')
                setAbbreviation('DEN')
                setWebsite('https://www.dentonmusicacademy.com')
                setLogoName('denton-logo__dark.png')
                setEmail('info@dentonmusicacademy.com') 
                setAddressState('TX')
            }
            else if (name === 'tempe') {
                setSchool('Tempe Music Academy')
                setAbbreviation('TEM')
                setWebsite('https://www.tempemusicacademy.com')
                setLogoName('tempe-logo__dark.png')
                setEmail('info@tempemusicacademy.com') 
                setAddressState('AZ')
            }
            else if (name === 'tulsa') {
                setSchool('Tulsa Music Academy')
                setAbbreviation('TUL')
                setWebsite('https://www.tulsamusicacademy.com')
                setLogoName('tulsa-logo__dark.png')
                setEmail('info@tulsamusicacademy.com') 
                setAddressState('OK')
            }
        }

        const typeInAnAddress = (value, values, setValues) => {
            let address = {
                addressLine1: value,
                addressLine2: '',
                city: '',
                state: '',
                zipcode: 0
            }
            setValues({...values, address})
        }
        const typeInCity = (value, values, setValues) => {
            let address = {
                addressLine1: value,
                addressLine2: '',
                city: '',
                state: '',
                zipcode: 0
            }
            setValues({...values, address})
        }

        const chooseALocation = (des, values, setValues) => {
            let address = {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipcode: 0
            }
            if(des.terms[0] && des.terms[1] && des.terms[2] && des.terms[3]) {
                address.addressLine1 = `${des.terms[0].value} ${des.terms[1].value}`
                address.city = des.terms[2].value
                address.state = des.terms[3].value
            } else {
                address.addressLine1 = des.description
            }
            setValues({...values, address})
        }

        const changeTheCard = (futureCard, currentCard, directionBlueIsTravelling, backgroundImageUrl) => {
            document.getElementById('blue-box').style.maxWidth = "550px"
            directionBlueIsTravelling === 'right' ? document.getElementById('blue-box').style.transition = "max-width 800ms 0ms, margin 300ms 800ms" : document.getElementById('blue-box').style.transition = "max-width 300ms 0ms, margin 800ms 0ms"
            setTimeout(() => {
                document.getElementById('blue-box').style.maxWidth = "100%"
            }, 1)
            document.getElementById(`card-${currentCard}`).style.opacity = 0
            setTimeout(() => {
                document.getElementById('new-student-form-background-image').style.opacity = 0
            },400)
            setTimeout(() => {
                document.getElementById('new-student-form-background-image').style.backgroundImage = backgroundImageUrl
                document.getElementById('new-student-form-background-image').style.opacity = 1
            }, 800)
            setTimeout(() => {
                setCard(futureCard)
                document.getElementById(`card-${futureCard}`).style.opacity = 1
                directionBlueIsTravelling === 'right' ? document.getElementById(`card-${futureCard}`).style.right = "0" : document.getElementById(`card-${futureCard}`).style.left = "0"
                document.getElementById('blue-box').style.maxWidth = "550px"
                document.getElementById('blue-box').style.width = "100%"
                directionBlueIsTravelling === 'right' ? document.getElementById(`blue-box`).style.right = "0" : document.getElementById(`blue-box`).style.left = "0"
                directionBlueIsTravelling === 'right' ? document.getElementById(`blue-box`).style.left = "auto" : document.getElementById(`blue-box`).style.right = "auto"
            }, 900)
        }

        const addAnotherStudent = (values, setValues) => {
            let students = values.students
            students.push({
                studentId: Math.random().toString(16).slice(2),
                studentName: '',
                dob: '',
                instrument: '',
                instrumentList: [],
                teachersId: '',
                experienceLevel: '-',
                lessonLength :0,
                lessonRate: 0,
                allRates: {15: 22, 30: 45, 45: 60, 60: 75},
                studentStatus: 'Being Onboarded',
                studentNotes: ''
            })
            setValues({...values, students})

        }

        const changeStudentInfo = (value, id, key, values, setValues) => {
            if(key === 'instrumentList') {
                let instObj = {}
                for(let i = 0; i < listOfInst.length; i++) {
                    if(listOfInst[i].id === value) {
                        instObj = listOfInst[i]
                    }
                }
                let students = values.students
                for(let i = 0; i < students.length; i++) {
                    if(students[i].studentId === id) {
                        let theStudentObject = students[i]
                        theStudentObject.instrumentList.push(instObj)
                        students[i] = theStudentObject
                    }
                }
                document.getElementById('new-student-form__student-dropdown-instrument-selector').value = ''
                setValues({...values, students})
            } else {
                let students = values.students
                for(let i = 0; i < students.length; i++) {
                    if(students[i].studentId === id) {
                        let theStudentObject = students[i]
                        theStudentObject[key] = value
                        students[i] = theStudentObject
                    }
                }
                setValues({...values, students})
            }
        }

        const removeInstFromStudentsList = (instName, stuId, values, setValues) => {
            let students = values.students
            for(let i = 0; i < students.length; i++) {
                if(students[i].studentId === stuId) {
                    for(let j = 0; j < students[i].instrumentList.length; j++) {
                        if(students[i].instrumentList[j].name === instName) {
                            students[i].instrumentList.splice(j, 1)
                            setValues({...values, students})
                        }
                    }
                }
            }
        }

        const removeStudentFromList = (id, values, setValues) => {
            let students = values.students
            for(let i = 0; i < students.length; i++) {
                if(students[i].studentId === id) {
                    students.splice(i , 1)
                    setValues({...values, students})
                }
            }
        }

        const sendFormToDatabase = () => {
            if(isSubmitting) {
                //DO NOTHING IF THEY ALREADY CLICKED THE BUTTON
            } else {
                setSubmitting(true)
                let newStudent = values
                document.getElementById('card-3').style.opacity = 0
                document.getElementById(`blue-box`).style.maxWidth = "100%"
                setTimeout(() => {
                    setLoading(true)
                }, 300)

    
                //------------SECURE FORM SYSTEM
                // let trimmedFamilyId = window.location.href.slice(16)
                // if(trimmedFamilyId.slice(-1) === '/') {
                //     trimmedFamilyId = trimmedFamilyId.substring(0, trimmedFamilyId.length - 1)
                // }
                // newStudent.familyId = trimmedFamilyId
    
                //-----------JUST GENERATE AN ID
                newStudent.familyId = Math.random().toString(16).slice(2)
                //----------------------------------
    
                newStudent.secondaryParentName = ''
                newStudent.school = `${abbreviation}`
                newStudent.secondaryEmail = ''
                newStudent.waveCustomerId = ''
                newStudent.secondaryCellphone = ''
                newStudent.primaryHomePhone = ''
                newStudent.secondaryHomePhone = ''
                newStudent.familyStatus = 'Being Onboarded'
                newStudent.onboardDate = Date()
                newStudent.schoolEmail = `${email}`
                newStudent.virtual = false
                newStudent.inHome = false
                newStudent.paymentType = ''
                newStudent.autoPay = false
                newStudent.moreAttention = false
                newStudent.policiesSigned = false
                newStudent.groupLessons = false
                newStudent.introLesson = true
                newStudent.membership = 0
                newStudent.password = 'password'
                newStudent.initialAvailability = {
                    Monday: [],
                    Tuesday: [],
                    Wednesday: [],
                    Thursday: [],
                    Friday: [],
                    Saturday: [],
                    Sunday: []
                  }
                newStudent.initialAvailabilityNotes = ''
                newStudent.needsToFillOutNewStudentForm = false
                newStudent.purchased = []
        
                // Axios.all([
                //     Axios.post(`${baseUrl}/school-management`, {
                //         newStudent: newStudent
                //     }),
                //     Axios.put(`${baseUrl}/studentinfobackup`, {
                //         newStudent: newStudent
                //     })
                // ])
                // .then(response => {
                //     //createStudentOnboardingWorkflowForNewStudentForm(newStudent, myFormCallback)
                //     createStudentOnboardingCard2022FromNewStudentForm(newStudent, myFormCallback)
                // })
                // .catch(e => {
                //     setMyError(true)
                //     console.log('ooops')
                //     console.log(e)
                // })
                Axios.post(`${baseUrl}/new-student-onboarding`, {
                    newStudent: newStudent
                })
                .then((res) => myFormCallback())
                .catch((err) => {
                    console.log(err)
                    setMyError(true)
                })
            }
        }

        const myFormCallback = () => {
            setSubmitting(false)
            setLoading(false)
            resetForm()
            changeTheCard(0, 3, 'left', `url(./${abbreviation}.jpg)`)
            setWeGotIt(true)
        }

        const closeThePopup = () => {
            window.location.href = website
        }

    return(
        <div className="new-student-form-two-window">
            {
                weGotIt && 
                <div className="we-got-it-wrapper">
                    <div className="we-got-it">
                        <div>
                            <div className="we-got-it__logo" style={{backgroundImage: `url(./${logoName})`}}></div>
                            <div>Thank you so much!</div>
                            <div>We'll get back to you soon.</div>
                        </div>
                        <div className="we-got-it-btn-wrapper">
                            <div className="new-student-form-btn first-card-btn" onClick={() => closeThePopup()}>close</div>
                        </div>
                    </div>
                </div>
            }
                        {
                myError && 
                <div className="we-got-it-wrapper">
                    <div className="we-got-it">
                        <div>
                            <div className="we-got-it__logo" style={{backgroundImage: `url(./${logoName})`}}></div>
                            <div>Ooops, somthing has gone wrong.</div>
                            <div>Please email us at {email}</div>
                            <div>Sorry about this!</div>
                        </div>
                        <div className="we-got-it-btn-wrapper">
                            <div className="new-student-form-btn first-card-btn" onClick={() => closeThePopup()}>close</div>
                        </div>
                    </div>
                </div>
            }
            {loading && <h1 className="sending-form-h1">Sending Form...</h1>}
            <Form onSubmit={handleSubmit}>
                <div className='new-student-form-background-image' id='new-student-form-background-image' style={{backgroundImage: `url(./${abbreviation}.jpg)`}}></div>
                <div className="new-student-form-two-box__blue-box" id="blue-box"></div>
                {/* ----------------------------CARD---------------------------- */}
                {
                    card === 0 && 
                    <div className="new-student-form__whole-card-wrapper">
                        <div className="new-student-form-two-box__left-side__form-wrapper" id="card-0">
                            <div className="new-student-form-two-box__logo-img" style={{backgroundImage: `url(./${logoName})`}}></div>
                                <div className="new-student-form-two-box__left-side__text-wrapper">
                                <h1>Welcome to {school}</h1>
                                <h3 className="form-subtitle">We have a few questions for you, this should take about 2 minutes.</h3>
                                <Field className="new-student-form-two-box__input-box__email" type="email" name="primaryEmail" placeholder="Enter Your Email"/>
                                {touched.primaryEmail && <p className="form-email-error">{errors.primaryEmail}</p>}
                                <div className="new-student-form-two-box__next-button-wrapper">
                                    {values.primaryEmail && !errors.primaryEmail && <div className="new-student-form-next-button" onClick={() => changeTheCard(1, 0, 'right', 'url(./about-img.jpg)')}>Next</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {/* ----------------------------CARD---------------------------- */}
                {
                    card === 1 &&
                    <div className="new-student-form__whole-card-wrapper">
                        <div className="new-student-form-two-box__left-side__form-wrapper" id="card-1">
                            <div onClick={() => changeTheCard(0 , 1, 'left', `url(./${abbreviation}.jpg)`)} className="new-student-form-two-back-arrow"></div>
                            <h2>Family Contact Information</h2>
                            {/* <Form> */}
                                <Field className="new-student-form-two-box__input-box__email bump-it-down" type="primaryParentName" name="primaryParentName" placeholder="Your First Name"/>
                                {touched.primaryParentName && <p className="form-email-error">{errors.primaryParentName}</p>}
                                <Field className="new-student-form-two-box__input-box__email" type="familyName" name="familyName" placeholder="Your Last Name"/>
                                {touched.familyName && <p className="form-email-error">{errors.familyName}</p>}
                                <Field type="primaryCellphone" name="primaryCellphone">
                                    {({field}) => (
                                        <MaskedInput
                                        {...field}
                                        mask={phoneNumberMask}
                                        placeholder="Primary Phone"
                                        type="text"
                                        name="primaryCellphone" 
                                        className={
                                           true ? "new-student-form-two-box__input-box__email" : 'not-good'
                                        } />
                                    )}
                                </Field>
                                {touched.primaryCellphone && <p className="form-email-error">{errors.primaryCellphone}</p>}
                                <Field className="new-student-form-two-box__input-box__email no-gap-on-bottom" name="address.addressLine1" placeholder="Enter Street Address..." />
                                <Field className="new-student-form-two-box__input-box__email no-gap-on-bottom" name="address.city" placeholder="City" />
                                <Field className="new-student-form-two-box__input-box__email no-gap-on-bottom" name="address.state" placeholder="State" />
                                <Field className="new-student-form-two-box__input-box__email no-gap-on-bottom" name="address.zipcode" placeholder="Zip Code" />
                                {touched.address && errors.address && <p className="form-email-error form-address-error">Address is Required</p>}
                                {/* <PlacesAutocomplete value={address} onChange={(e) => handleChange(e, values, setValues)} onSelect={handleSelect}>
                                    {({
                                        getInputProps, 
                                        suggestions, 
                                        getSuggestionItemProps, 
                                        loading
                                    }) => (
                                        <div>
                                            <div className="address-suggestions__wrapper">
                                                {loading && <div>Loading... </div>}
                                                {suggestions.map((suggestion) => {
                                                    const style = suggestion.active ? {backgroundColor: '#73A2BF', borderBottom: '1px solid #fff', color: "#fff", cursor: "pointer"} : {backgroundColor: "#73A2BF", borderBottom: '1px solid #73A2BF', color: "#fff", cursor: "default"}
                                                    return (
                                                        <div className="address-suggestions" key={suggestion.placeId} {...getSuggestionItemProps(suggestion, {style})}>
                                                            <p key={suggestion.placeId} onClick={() => chooseALocation(suggestion, values, setValues)}>{suggestion.description}</p>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </PlacesAutocomplete> */}
                                <h3 className="dont-sell-data">We never share or sell your data, ever.</h3>
                                <div className="new-student-form-two-box__next-button-wrapper">
                                    {values.primaryParentName && !errors.primaryParentName && values.familyName && !errors.familyName && values.primaryCellphone && !errors.primaryCellphone && !errors.address.addressLine1 && values.address.addressLine1 && !errors.address.city && values.address.city && !errors.address.state && values.address.state && !errors.address.zipcode && values.address.zipcode && <div className="new-student-form-next-button" onClick={() => changeTheCard(2, 1, 'left', 'url(./privateteacherinboulder.jpg)')}>Next</div>}
                                </div>
                            {/* </Form> */}
                        </div>
                    </div>
                }
                {/* ----------------------------CARD---------------------------- */}
                {
                    card === 2 && 
                    <div className="new-student-form__whole-card-wrapper">
                        <div className="new-student-form-two-box__left-side__form-wrapper" id="card-2">
                            <div onClick={() => changeTheCard(1 , 2, 'right', `url(./about-img.jpg)`)} className="new-student-form-two-back-arrow"></div>
                            <h2>Student Information</h2>
                            <FieldArray name="students">
                                {() => (values.students.map((student, index) => {
                                    return(
                                        <div className="new-student-form__student-box" key={index}>
                                            {index !== 0 && <h5 onClick={() => removeStudentFromList(student.studentId, values, setValues)} className="new-student-form__remove-student-x">X</h5>}
                                            <Field name={`students.${index}.studentName`} onChange={(e) => changeStudentInfo(e.target.value, student.studentId, 'studentName', values, setValues)}  className="new-student-form-two-box__input-box__email new-student-form-half-width-input-box" type="studentName" placeholder="Student's First Name"/>
                                            <Field name={`students.${index}.dob`}  onChange={(e) => changeStudentInfo(e.target.value, student.studentId, 'dob', values, setValues)} type="dob">
                                            {({field}) => (
                                                <MaskedInput
                                                {...field}
                                                mask={dateMask}
                                                placeholder="DOB (mm/dd/yyyy)"
                                                type="text"
                                                // onChange={handleChange}
                                                // onBlur={onBlur}
                                                className={
                                                   true ? "new-student-form-two-box__input-box__email new-student-form-half-width-input-box" : 'not-good'
                                                } />
                                            )}</Field>
                                            {/* <Field name={`students.${index}.instrument`}  onChange={(e) => changeStudentInfo(e.target.value, student.studentId, 'instrument', values, setValues)} className="new-student-form-two-box__input-box__email new-student-form-half-width-input-box" type="instrument" placeholder="Instrument"/> */}
                                            <div className='new-student-form__chip-wrapper'>
                                                {student.instrumentList.map((inst) => (
                                                        <div className='new-student-form__chip' key={inst.id}>
                                                            <div className='new-student-form__chip-name'>{inst.name}</div>
                                                            <div className='new-student-form__chip-x' onClick={() => removeInstFromStudentsList(inst.name, student.studentId, values, setValues)}>x</div>
                                                        </div>
                                                ))}
                                            </div>
                                            <select id="new-student-form__student-dropdown-instrument-selector" onChange={(e) => changeStudentInfo(e.target.value, student.studentId, 'instrumentList', values, setValues)} className='new-student-form__student-inst-dropdown'>
                                                {student.instrumentList.length === 0 ? <option value='' default>Select Instrument</option> : <option value='' default>Add Another Instrument</option> }
                                                {listOfInst.map((inst) => <option key={inst.id} value={inst.id}>{inst.name}</option>)}
                                            </select>
                                            <select className='new-student-form__experience-dropdown' onChange={(e) => changeStudentInfo(e.target.value, student.studentId, 'experienceLevel', values, setValues)} >
                                                <option value="-" default>Choose Experience Level</option>
                                                <option value="no experience">First Time</option>
                                                <option value="1 year">1 year</option>
                                                <option value="2 years">2 years</option>
                                                <option value="+2 years">+2 years</option>
                                            </select>
                                            <div className="new-student-form__new-student-underline"></div>
                                        </div>
                                    )
                                }))}
                            </FieldArray>
                            <div className="new-student-form-next-button add-student-button" style={{margin: '30px auto'}} onClick={() => addAnotherStudent(values, setValues)}>+ Another Student</div>
                            {
                            values.students[0].studentName && 
                            <div className="new-student-form-two-box__next-button-wrapper">
                                <div onClick={() => changeTheCard(3, 2, 'right', 'url(./privatelessonsinboulder.jpg)')} className="new-student-form-next-button">Next</div>
                            </div>
                            }
                        </div>
                    </div>
                }
                {/* ----------------------------CARD---------------------------- */}
                {
                    card === 3 && 
                    <div className="new-student-form__whole-card-wrapper">
                        <div className="new-student-form-two-box__left-side__form-wrapper" id="card-3">
                            <div onClick={() => changeTheCard(2 , 3, 'left', `url(./privatelessonsinboulder.jpg)`)} className="new-student-form-two-back-arrow"></div>
                            <h2>Last Questions</h2>
                            {/* <Form> */}
                                <div>
                                    <label>Describe Your Availability</label>
                                    <Field className="new-student-form-two-box__input-box__email text-area-availability-box" component="textarea" type="textarea" name="availability" placeholder="We're available..."/>
                                </div>
                                <div>
                                    <label>How Did You Find Us?</label>
                                    <Field className="new-student-form__how-did-you-hear" component="select" name="hearOfUs">
                                        <option value="-">Select</option>
                                        <option value="google">Google</option>
                                        <option value="lessons">Lessons.com</option>
                                        <option value="facebook">Facebook</option>
                                        <option value="craigslist">Craigslist</option>
                                        <option value="instagram">Instagram</option>
                                        <option value="referral">Referral</option>
                                    </Field>
                                </div>
                                {values.hearOfUs === 'referral' && 
                                    <div className="new-student-form__referral-input">
                                        <Field className="new-student-form-two-box__input-box__email" type="text" name="referral" placeholder="Who referred you?" />
                                    </div>
                                }
                            {/* </Form> */}
                            {isSubmitting ? <p style={{color: '#fff'}}>sending information</p> : <button type="submit" onClick={() => sendFormToDatabase()} className="new-student-form-next-button final-button-in-form">Complete Form</button>}
                        </div>
                    </div>
                }
            </Form>
        </div>
    )
}

const FormikApp = withFormik({
    mapPropsToValues() {
        return {
            primaryEmail: '',
            students: [{
                studentId: Math.random().toString(16).slice(2),
                studentName: '',
                dob: '',
                instrument: '',
                instrumentList: [],
                teachersId: '',
                experienceLevel: '-',
                lessonLength :0,
                lessonRate: 0,
                allRates: {15: 22, 30: 45, 45: 60, 60: 75},
                studentStatus: 'Being Onboarded',
                studentNotes: ''
            }],
            familyName: '',
            primaryParentName: '',
            primaryCellphone: '',
            address: {
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipcode: null
            },
            availability: '',
            hearOfUs: '',
            referral: ''
        }
    },
    validationSchema: Yup.object().shape({
        primaryEmail: Yup.string().email('Email not valid').max(50, 'email is too long').required('Email is required'),
        familyName: Yup.string().min(2, 'Name must be atleast 2 characters').max(50, 'name is too long').required('Family Name is Required'),
        primaryParentName: Yup.string().min(2, 'Name must be atleast 2 characters').max(50, 'name is too long').required('First Name is Required'),
        familyName: Yup.string().min(2, 'Last name must be at least 2 characters long').max(50, 'name is too long').required('Last Name is Required'),
        primaryCellphone: Yup.string().min(9, 'Please enter complete phone number').required('Phone number is required'),
        students: Yup.array().of(
            Yup.object().shape({
                studentName: Yup.string().min(2, 'Enter complete name').max(25, 'name is too long').required('Student\'s name is required')
            })
        ),
        address: Yup.array().of(
            Yup.object().shape({
                addressLine1: Yup.string().min(7, 'Must be a complete address').required('Address is required'),
                city: Yup.string().min(2, 'Must be a complete city').required('City is required'),
                zipcode: Yup.number().min(5, 'Must be a complete zip code').required('Zip is required')
            })
        )
    }),
    // handleSubmit(values, {setErrors, resetForm, setSubmitting}) {
    //     console.log('called')
    //     setTimeout(() => {
    //         if(values.primaryEmail === 'test@test.com') {
    //             setErrors({ primaryEmail: 'That email is aready taken.'})
    //             console.log('yup')
    //         } else {
    //             resetForm()
    //             console.log('yay!')
    //         }
    //         setSubmitting(false)
    //     }, 2000)
    //     console.log(values)
    // }
})(NewStudentFormTwo)
export default FormikApp;